// Fonction réutilisable pour calculer le prix de VENTE
function calculateCustomPrice({ 
  basePrice, 
  height, 
  length, 
  quantity, 
  standardHeight, 
  standardLength, 
  tauxremisep1, 
  tauxremisep2, 
  tauxremisep3,
  hauteurCoefForfaitaire = 1.15,
  longueurCoefForfaitaire = 1.2,
  longueurMtForfaitaireUnitaire = 2.4,
  longueurMtForfaitaireLigne = 36 
}) {
  if (!height || !length || !standardHeight || !standardLength || tauxremisep1 == null || tauxremisep2 == null || tauxremisep3 == null) {
    return basePrice;
  }

  // 1. Remises par quantité (Appliquée sur le prix de base)
  let initialPrice;
  if (quantity < 3) {
    initialPrice = basePrice;
  } else if (quantity < 25) {
    initialPrice = basePrice * (1 - tauxremisep1 / 100);
  } else if (quantity < 50) {
    initialPrice = basePrice * (1 - tauxremisep2 / 100);
  } else {
    initialPrice = basePrice * (1 - tauxremisep3 / 100);
  }

  // 2. Calcul du prix de la hauteur : + 1% par cm supplémentaire + 15% (Basé sur le prix remisé)
  // Utilisation de Math.max pour s'assurer que le coeff ne descend pas en dessous de 1
  const isCustomHeight = height !== standardHeight;
  const heightCoeff = Math.max(1, (height - standardHeight) / 1000 + 1);
  const heightPrice = isCustomHeight ? initialPrice * heightCoeff * hauteurCoefForfaitaire : initialPrice;

  // 3. Calcul du prix de la longueur : + 20% + 2.40€ TTC par bandeau + forfait 36€ TTC pour toute la ligne
  const isCustomLength = length !== standardLength;
  const lengthCoeff = length / standardLength;
  const finalPrice = isCustomLength 
    ? ((((heightPrice * lengthCoeff * longueurCoefForfaitaire) + longueurMtForfaitaireUnitaire) * quantity) + longueurMtForfaitaireLigne) / quantity
    : heightPrice;

  return Math.ceil(finalPrice * 100) / 100;
}

// Exporter pour utilisation globale
window.calculateCustomPrice = calculateCustomPrice;